/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../../shared/qrequest";
import BaseCom from "../../BaseCom";
import FormInput from "../../FormInput";
import L from "../../Lang";

export default class GiftCard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                cardHolderName: 'dummy',
                processType: 'gc',
                billing: {},
                payment: {}
            }
        }
    }

    submit = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let info = { ...this.state.info };
            info.amount = this.props.session.amount;
            info.sid = this.props.session.sid;
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }


    // TODO: add verify amount?

    render() {
        return <form onSubmit={this.submit}>
        <div className="row">
            <div className="col-md-12">
                <h2>Gift Card</h2>
                <FormInput model={this.state.info} name="cardNumber" label="Gift Card Number" onChange={this.change} placeholder="•••• •••• •••• ••••" required />
            </div>
        </div>
        <div className="d-grid my-2">
            <button type="submit" className="btn btn-primary btn-lg"><L>Pay with Gift Card</L></button>
            <button type="button" className="btn btn-lg" onClick={this.props.onCancel}><L>Select a different Payment Method</L></button>
        </div>
    </form>;
    }
}